
























































import Vue from 'vue';
import Component from 'vue-class-component';
import { isDateValidFn } from '@cnamts/vue-dot/src/rules/isDateValid';
import dayjs from 'dayjs';
import 'dayjs/locale/fr';
import _ from 'lodash';

const Props = Vue.extend({
	props: {
		/** The v-model value */
		value: {
			type: String,
			default: ''
		},
		dateMin: {
			type: String,
			default: ''
		},
		dateMax: {
			type: String,
			default: ''
		},
		datePickerRules: {
			type: [Array, Object],
			default: () => ([])
		},
		startDate: {
			type: String,
			default: ''
		},
		openWithDateMin: {
			type: Boolean,
			default: false
		},
		disabled: {
			type: Boolean,
			default: false
		},
		placeholder: {
			type: String,
			default: 'JJ/MM/AAAA'
		}
	}
});

/** DatePicker from Vue Dot with special configuration */
@Component({
	// Define custom v-model,
	// prop name is value, event name is change
	model: {
		prop: 'value',
		event: 'change'
	}
})
export default class P2DatePicker extends Props {
	isoDateToday: string = dayjs().format('YYYY-MM');
	error = false;
	internalPickerDate = this.calcInternalPickerDate;

	/**
	 * Vérifier la présence d'erreur sur le calendrier
	 */
	handleError(error: boolean): void {
		this.error = error;
	}

	/**
	 * Met à jour le calendrier lorsqu'on saisie une date
	 * dans le champ input et repositionne le calendrier à
	 * la date du jour si la valeur est nulle
	 */
	handleInput(value: string): void {
		if (!_.isEmpty(value)) {
			// Si c'est une date valide, alors on met à jour le calendrier
			const isDateValid = isDateValidFn()(value);
			if (typeof isDateValid === 'boolean' && isDateValid) {
				this.computedValue = value;
				this.internalPickerDate = dayjs(value, 'YYYY-MM').format();
			}
		} else {
			// On repositionne le calendrier sur la date du jour
			this.computedValue = value;
			this.internalPickerDate = this.isoDateToday;
		}
		this.$emit('input', value);
	}

	getWeekday(date: string): string {
		return dayjs(date).locale('fr').format('dddd').charAt(0).toUpperCase();
	}

	get calcInternalPickerDate() {
		if (this.openWithDateMin) {
			return this.dateMinIso;
		}
		return this.error ? this.isoDateToday : null;
	}

	get dateMinIso() {
		return dayjs(this.dateMin).format('YYYY-MM');
	}

	// computedValue is computed property
	// with a setter and a getter
	// Return the value
	get computedValue(): string {
		return this.value;
	}

	// Emit the updated value
	set computedValue(value: string) {
		this.$emit('change', value);
	}

	get isIE(): boolean {
		const userAgent = _.get(window, 'navigator.userAgent', '');
		return _.includes(userAgent, 'MSIE') || _.includes(userAgent, 'Trident/');
	}
}
